import React from 'react';
import ReactEcharts from 'echarts-for-react';

export const EChartField = ({ record = {}}) =>
    record && record.CpuBarChart ? <ReactEcharts
        option={record.CpuBarChart}
        style={{height: '500%', width: '100%'}}/> : <span/> ;
